import { FormikProvider } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import MultiMediaTableForm from "../../../common/MultiMediaTableForm";
import { withTranslation } from "react-i18next";
import { Form, Label, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { HOME_PAGE, TYPE_SAVE } from "../../../../helpers/constants";
import { deleteWebsitePagesInformation, getWebsitePagesInformation } from "../../../../store/website-pages/actions";
import Loader from "../../../common/Loader";

import { checkImageFileValidation, checkVideoFileValidation } from "../../../../helpers/utils";
import ImageCropperModal from "../../../common/ImageCropperModal";
import ActionButton from "../../../common/ActionButton";

const HomePageContent = (props) => {
  const dispatch = useDispatch();
  const [infoLoader, setInfoLoader] = useState(false);
  const [infoPayload] = useState({
    filter: {
      website_page: props.website_page,
      language_type: props.type,
      save_type: TYPE_SAVE,
    },
  });
  const [isImageCropperModalOpen, setIsImageCropperModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState();
  const [selectedArrayKey, setSelectedArrayKey] = useState();

  // to get the home page information
  const handleGetPageInformation = useCallback(
    (payload) => {
      setInfoLoader(true);
      dispatch(getWebsitePagesInformation(payload, HOME_PAGE)).then(() => {
        setInfoLoader(false);
      });
    },
    [dispatch]
  );

  useEffect(() => {
    handleGetPageInformation(infoPayload);
  }, [infoPayload, handleGetPageInformation]);

  const handleDeleteItem = (payload, setDeleteLoader, closeModal, boundArrayHelpers, itemIndex) => {
    setDeleteLoader(true);
    dispatch(deleteWebsitePagesInformation(payload)).then((res) => {
      if (res) {
        boundArrayHelpers?.remove(itemIndex);
      }
      setDeleteLoader(false);
      closeModal();
    });
  };

  // to reset form on unmount
  useEffect(() => {
    return () => {
      props?.validation?.resetForm();
    };
  }, []);

  // handle image modal open
  const handleLinkToAuctionModalOpen = () => {
    setIsImageCropperModalOpen(true);
  };
  // handle image modal close
  const handleImageCropModalClose = () => {
    setIsImageCropperModalOpen(false);
  };

  // gets the cropped image file and sets in the form
  const handleImageCrop = (file) => {
    const selectedRowData = props?.validation?.values?.[selectedArrayKey]?.[selectedImageIndex];

    props?.validation?.setFieldValue(`${selectedArrayKey}.${selectedImageIndex}`, {
      ...selectedRowData,
      file,
    });
    handleImageCropModalClose();
  };

  return (
    <FormikProvider value={props?.validation}>
      <Form
        className="position-relative"
        onSubmit={(e) => {
          e.preventDefault();
          props?.validation.handleSubmit();
          return false;
        }}
      >
        {infoLoader ? <Loader /> : null}
        {/* carousel */}
        <Row>
          <div className="mb-3">
            <Label className="form-label fw-bold">{`${props.t("common.carousel")}`}</Label>
            <MultiMediaTableForm
              validation={props?.validation}
              arrayKey="carousel"
              sectionName={props.t("common.item")}
              defaultRowValues={{
                order_no: "",
                file: "",
                title: "",
                subtitle: "",
                link: "",
              }}
              handleDeleteItem={handleDeleteItem}
              columns={[
                {
                  label: props.t("common.no_"),
                  spacing: { sm: 1, md: 1, lg: 1 },
                  type: "number",
                  key: "order_no",
                },
                {
                  key: "file",
                  label: `${props.t("common.image")}`,
                  actionButtons: [
                    {
                      Component: (index, arrayKey) => (
                        <ActionButton
                          iconClasses="ri-crop-2-fill fs-18 cursor-pointer"
                          buttonId={`tooltip-${arrayKey}-${index}-cropping`}
                          tooltip={props.t("common.cropImage")}
                          onClick={() => {
                            setSelectedImageIndex(index);
                            setSelectedArrayKey(arrayKey);
                            handleLinkToAuctionModalOpen();
                          }}
                        />
                      ),
                      fileType: "image",
                    },
                  ],
                  spacing: { sm: 4, md: 4, lg: 4 },
                  type: "file",
                  accept: "image/*",
                  checkFileTypeValidation: (fileName) => {
                    return checkImageFileValidation(fileName) || checkVideoFileValidation(fileName);
                  },
                },
                {
                  key: "title",
                  label: props.t("common.title"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "subtitle",
                  label: props.t("common.subTitle"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "link",
                  label: `${props.t("common.website")} ${props.t("common.link")}`,
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
              ]}
            />
          </div>
        </Row>
        {/* blocks */}
        <Row>
          <div className="mb-3">
            <Label className="form-label fw-bold">{`${props.t("common.blocks")}`}</Label>
            <MultiMediaTableForm
              validation={props?.validation}
              arrayKey="block"
              sectionName={props.t("common.block")}
              defaultRowValues={{ file: "", title: "", subtitle: "", link: "" }}
              handleDeleteItem={handleDeleteItem}
              columns={[
                {
                  label: props.t("common.no_"),
                  spacing: { sm: 1, md: 1, lg: 1 },
                  type: "number",
                  key: "order_no",
                },
                {
                  key: "file",
                  label: `${props.t("common.image")}`,
                  actionButtons: [
                    {
                      Component: (index, arrayKey) => (
                        <ActionButton
                          iconClasses="ri-crop-2-fill fs-18 cursor-pointer"
                          buttonId={`tooltip-${arrayKey}-${index}-cropping`}
                          tooltip={props.t("common.cropImage")}
                          onClick={() => {
                            setSelectedImageIndex(index);
                            setSelectedArrayKey(arrayKey);
                            handleLinkToAuctionModalOpen();
                          }}
                        />
                      ),
                      fileType: "image",
                    },
                  ],
                  spacing: { sm: 4, md: 4, lg: 4 },
                  type: "file",
                  accept: "image/*",
                  checkFileTypeValidation: (fileName) => {
                    return checkImageFileValidation(fileName) || checkVideoFileValidation(fileName);
                  },
                },
                {
                  key: "title",
                  label: props.t("common.title"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "subtitle",
                  label: props.t("common.subTitle"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "link",
                  label: `${props.t("common.website")}/${props.t("common.vimeo")} ${props.t("common.link")}`,
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
              ]}
            />
          </div>
        </Row>
        {/* banners */}
        <Row>
          <div className="mb-3">
            <Label className="form-label fw-bold">{`${props.t("common.banners")}`}</Label>
            <MultiMediaTableForm
              validation={props?.validation}
              arrayKey="banner"
              sectionName={props.t("common.banner")}
              defaultRowValues={{ file: "", title: "", subtitle: "", link: "" }}
              handleDeleteItem={handleDeleteItem}
              columns={[
                {
                  label: props.t("common.no_"),
                  spacing: { sm: 1, md: 1, lg: 1 },
                  type: "number",
                  key: "order_no",
                },
                {
                  key: "file",
                  label: `${props.t("common.image")}`,
                  actionButtons: [
                    {
                      Component: (index, arrayKey) => (
                        <ActionButton
                          iconClasses="ri-crop-2-fill fs-18 cursor-pointer"
                          buttonId={`tooltip-${arrayKey}-${index}-cropping`}
                          tooltip={props.t("common.cropImage")}
                          onClick={() => {
                            setSelectedImageIndex(index);
                            setSelectedArrayKey(arrayKey);
                            handleLinkToAuctionModalOpen();
                          }}
                        />
                      ),
                      fileType: "image",
                    },
                  ],
                  spacing: { sm: 4, md: 3, lg: 4 },
                  type: "file",
                  accept: "image/*",
                  checkFileTypeValidation: (fileName) => {
                    return checkImageFileValidation(fileName) || checkVideoFileValidation(fileName);
                  },
                },
                {
                  key: "title",
                  label: props.t("common.title"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "subtitle",
                  label: props.t("common.subTitle"),
                  spacing: { sm: 2, md: 2, lg: 2 },
                  type: "text",
                },
                {
                  key: "link",
                  label: `${props.t("common.website")}/${props.t("common.vimeo")} ${props.t("common.link")}`,
                  spacing: { sm: 3, md: 3, lg: 2 },
                  type: "text",
                },
              ]}
            />
          </div>
        </Row>
      </Form>
      <ImageCropperModal
        isModalOpen={isImageCropperModalOpen}
        onCancel={handleImageCropModalClose}
        title={props.t("common.cropImage")}
        src={props?.validation?.values?.[selectedArrayKey]?.[selectedImageIndex]?.file}
        handleImageCrop={handleImageCrop}
      />
    </FormikProvider>
  );
};

export default withTranslation()(HomePageContent);
